export const MODULES =
    [      
        {
        "id": 0,
        "name":"Time of Rise Versus Time of Fall",
        "image": "/assets/images/time_of_rise.png",
        "video": "/assets/video/video_1",
        "youtube":"https://www.youtube.com/embed/-MWkN9iIo6I",
        "language": "English",
        "level":"2",
        "topic":"Laws of Motion",
        "subject":"Physics",
        "std":"XI",
        "rating":"4",
        "featured": true,
        "description":"To measure the time of rise and fall using ball",
        "body":"This space contains the details of hypothesis section to be presented to students",
        "method":"This space contains materials and methods",
        "exp_you":"https://www.youtube.com/embed/-MWkN9iIo6I",
		"exp_video":"",
		"exp_simulation":"",
		"exp_image":"",
        "exp_body":" This space contains the details of experiment section to be presented to students",
        "author_id":"123",
        "author": "Nitesh Jha",
        "date": "2012-10-16"                    
        }                    
        ,
        {
        "id": 1,
        "name":"Measuring the Height of a House",
        "image": "/assets/images/measuring_height.png",
		"video": "/assets/video/video_1",
        "youtube":"https://www.youtube.com/embed/-MWkN9iIo6I",
        "language": "English",
        "level":"3",
        "topic":"Laws of Motion",
        "subject":"Physics",
        "std":"X",
        "rating":"3",
        "featured": false,
        "description":"To measure the height of house",
        "body":"This space contains the details of hypothesis section to be presented to students",
        "method":"This space contains materials and methods",
        "exp_you":"https://www.youtube.com/embed/-MWkN9iIo6I",
		"exp_video":"",
		"exp_simulation":"",
		"exp_image":"",
        "exp_body":" This space contains the details of experiment section to be presented to students",
        "author_id":"123",
        "author": "Nitesh Jha",
        "date": "2012-10-16"
        },
{
        "id": 2,
        "name":"Testing the hardness of water",
        "image": "/assets/images/measuring_height.png",
		"video": "/assets/video/video_1",
        "youtube":"https://www.youtube.com/embed/-MWkN9iIo6I",
        "language": "English",
        "level":"2",
        "topic":"Hardness of water",
        "subject":"Chemistry",
        "std":"X",
        "rating":"3",
        "featured": false,
        "description":"To test the hardness of water",
        "body":"This space contains the details of hypothesis section to be presented to students",
        "method":"This space contains materials and methods",
        "exp_you":"https://www.youtube.com/embed/-MWkN9iIo6I",
		"exp_video":"",
		"exp_simulation":"",
		"exp_image":"",
		"exp_body":" This space contains the details of experiment section to be presented to students",
        "author": "Nitesh Jha",
        "author_id":"123",
        "date": "2012-10-16"
        },
        {
        "id": 4,
        "name":"How sanitary is water from school tap",
        "image": "/assets/images/measuring_height.png",
		"video": "/assets/video/video_1",
        "youtube":"https://www.youtube.com/embed/-MWkN9iIo6I",
        "language": "English",
        "level":"3",
        "topic":"Laws of Motion",
        "subject":"Chemistry",
        "std":"IX",
        "rating":"3",
        "featured": false,
        "description":"To test the quality of water from school tap",
        "body":"This space contains the details of hypothesis section to be presented to students",
        "method":"This space contains materials and methods",
        "exp_you":"https://www.youtube.com/embed/-MWkN9iIo6I",
		"exp_video":"",
		"exp_simulation":"",
		"exp_image":"",
        "exp_body":" This space contains the details of experiment section to be presented to students",
        "author_id":"123",
        "author": "Nitesh Jha",
        "date": "2012-10-16"
        },
        {
            "id": 5,
            "name":"Comparing quality of water in different branded water bottles ",
            "image": "/assets/images/measuring_height.png",
            "video": "/assets/video/video_1",
            "youtube":"https://www.youtube.com/embed/-MWkN9iIo6I",
            "language": "English",
            "level":"3",
            "topic":"Laws of Motion",
            "subject":"Chemistry",
            "std":"VIII",
            "rating":"3",
            "featured": false,
            "description":"To compare the quality of water in different water bottles",
            "body":"This space contains the details of hypothesis section to be presented to students",
            "method":"This space contains materials and methods",
            "exp_you":"https://www.youtube.com/embed/-MWkN9iIo6I",
            "exp_video":"",
            "exp_simulation":"",
            "exp_image":"",
            "exp_body":" This space contains the details of experiment section to be presented to students",
            "author_id":"123",
            "author": "Nitesh Jha",
            "date": "2012-10-16"
        }
        ,
        {
            "id": 6,
            "name":"How does the type of soil affect the drainage of water through soil",
            "image": "/assets/images/measuring_height.png",
            "video": "/assets/video/video_1",
            "youtube":"https://www.youtube.com/embed/-MWkN9iIo6I",
            "language": "English",
            "level":"3",
            "topic":"Water drainage in Soil",
            "subject":"Chemistry",
            "std":"VIII",
            "rating":"3",
            "featured": false,
            "description":"To measure the height of house",
            "body":"This space contains the details of hypothesis section to be presented to students",
            "method":"This space contains materials and methods",
            "exp_you":"https://www.youtube.com/embed/-MWkN9iIo6I",
            "exp_video":"",
            "exp_simulation":"",
            "exp_image":"",
            "exp_body":" This space contains the details of experiment section to be presented to students",
            "author_id":"113",
            "author": "Saurabh Pandey",
            "date": "2012-10-16"
        }
        ,
        {
            "id": 7,
            "name":"Factors that affect the swing of pendulum: mass of object at the end",
            "image": "/assets/images/measuring_height.png",
            "video": "/assets/video/video_1",
            "youtube":"https://www.youtube.com/embed/-MWkN9iIo6I",
            "language": "English",
            "level":"3",
            "topic":"Motions energy",
            "subject":"Physics",
            "std":"IX",
            "rating":"3",
            "featured": true,
            "description":"To measure the factor-mass of object at end, that affects the swing of pendulum",
            "body":"This space contains the details of hypothesis section to be presented to students",
            "method":"This space contains materials and methods",
            "exp_you":"https://www.youtube.com/embed/-MWkN9iIo6I",
            "exp_video":"",
            "exp_simulation":"",
            "exp_image":"",
            "exp_body":" This space contains the details of experiment section to be presented to students",
            "author_id":"113",
            "author": "Saurabh Pandey",
            "date": "2012-10-16"
        }
        ,
        {
            "id": 8,
            "name":"Factors that affect the swing of pendulum:Length of string",
            "image": "/assets/images/measuring_height.png",
            "video": "/assets/video/video_1",
            "youtube":"https://www.youtube.com/embed/-MWkN9iIo6I",
            "language": "English",
            "level":"3",
            "topic":"Motions energy",
            "subject":"Physics",
            "std":"VIII",
            "rating":"3",
            "featured": false,
            "description":"To measure the factor-Length of string, that affects the swing of pendulum",
            "body":"This space contains the details of hypothesis section to be presented to students",
            "method":"This space contains materials and methods",
            "exp_you":"https://www.youtube.com/embed/-MWkN9iIo6I",
            "exp_video":"",
            "exp_simulation":"",
            "exp_image":"",
            "exp_body":" This space contains the details of experiment section to be presented to students",
            "author_id":"123",
            "author": "Nitesh Jha",
            "date": "2012-10-16"
        }
        ,
        {
            "id": 9,
            "name":"Factors that affect the swing of pendulum: Distance the object is pulled back and released",
            "image": "/assets/images/measuring_height.png",
            "video": "/assets/video/video_1",
            "youtube":"https://www.youtube.com/embed/-MWkN9iIo6I",
            "language": "English",
            "level":"3",
            "topic":"Motions energy",
            "subject":"Physics",
            "std":"VIII",
            "rating":"3",
            "featured": false,
            "description":"To measure the factor-Distance the object is pulled back, that affects the swing of pendulum",
            "body":"This space contains the details of hypothesis section to be presented to students",
            "method":"This space contains materials and methods",
            "exp_you":"https://www.youtube.com/embed/-MWkN9iIo6I",
            "exp_video":"",
            "exp_simulation":"",
            "exp_image":"",
            "exp_body":" This space contains the details of experiment section to be presented to students",
            "author_id":"113",
            "author": "Saurabh Pandey",
            "date": "2012-10-16"
        }
    ];